export const Calendar = () => {
  return (
    <iframe title="Calendar" src="https://calendar.google.com/calendar/embed?src=c_73c27b39440d673e1ce17b7c9834bd3bfb0b2c2f8168044a0c65c740d88adfea%40group.calendar.google.com&ctz=America%2FDenver&pli=1" width="100%" height="800px" />
  )
}